module.exports = __webpack_public_path__ + "static/media/count.00808de5.svg";